module.exports = __webpack_public_path__ + "static/media/Benefit Highlights with Cover CSNP.3bc19bfc.pdf";